<template>
  <div>
    <el-row>
      <TableContainer
        CustomTableArticle
        :columns="containerTableColumns"
        :serverUrl="containerServerUrl"
        :baseUrl="containerBaseUrl"
        :tableToolConfig="tableToolConfig"
        ref="TableContainer"
      >
        <template v-slot:tools>
          <!-- <router-link :to="containerBaseUrl + '/add'">
            <el-button type="primary" icon="el-icon-circle-plus-outline">增加后台用户</el-button>
          </router-link> -->
        </template>

        <template v-slot:filter>
          <!-- <selectTableFilterStatus
            @DoChange="DoChangeStatus"
            showReview
            showDraft
            ref="selectTableFilterStatusRef"
          ></selectTableFilterStatus>-->
        </template>

        <!--  -->
        <template v-slot:table__footer__info>权限列表</template>
      </TableContainer>

      <!-- <el-row>
          <p class="paragraph-content-small grey asset"><i class="el-icon-info"></i> 当前列表项的显示顺序，即是网站相关项目的显示顺序。</p>
      </el-row>-->
    </el-row>
  </div>
</template>
<script>
import { BaseVue } from "@/mixin/index";
import { TableContainer } from "@/core/table/";

export default {
  name: "Role",
  
  mixins: [BaseVue],
  
  components: {
    TableContainer
  },
  
  data() {
    return {
      // table 头
      containerTableColumns: [
        {
          prop: "content",
          label: "权限名",
          width: "200px"
        }
      ],
      // 基础地址
      containerBaseUrl: "/standard/role",
      // api的基础地址
      containerServerUrl: "/api/manager/role",
      // table config 设置
      tableToolConfig: {
        canEdit: true,
        canRecover: false,
        canDelete: false,
        canDisable: false
      }
    };
  },
  
  mounted() {
    // 组件挂载后的逻辑
  }
};
</script>

<style scoped>
</style>

